import { StateCreator } from "zustand";

export interface DocumentPickerOpenState {
    [x: string]: HTMLElement | null;
}

export interface DocumentPickerSlice {
    documentPickerOpen: DocumentPickerOpenState;
    setDocumentPickerOpen: (state: DocumentPickerOpenState) => void;
    resetDocumentPickerOpen: () => void;
}

const initialDocumentPickerOpenState: DocumentPickerOpenState = {};

export const createDocumentPickerSlice: StateCreator<DocumentPickerSlice, [], [], DocumentPickerSlice> = (set) => ({
    documentPickerOpen: initialDocumentPickerOpenState,

    setDocumentPickerOpen: (state) => set({ documentPickerOpen: state }),
    resetDocumentPickerOpen: () => set({ documentPickerOpen: initialDocumentPickerOpenState }),
});

